import * as React from "react";

import { trimPastedText } from "@/lib/trim-paste";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
    ({ className, type, autoComplete = "off", onPaste, ...props }, ref) => {
        return (
            <input
                autoComplete={autoComplete}
                className={cn(
                    "flex h-9 w-full rounded-md border border-neutral-200 bg-white px-3 py-1 text-base text-neutral-950 shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950 placeholder:text-neutral-500 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-neutral-950 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-50 dark:file:text-neutral-50 dark:placeholder:text-neutral-400 dark:focus-visible:ring-neutral-300",
                    className,
                )}
                onPaste={(e) => {
                    onPaste?.(e);
                    if (!e.defaultPrevented && type !== "password") {
                        trimPastedText(e);
                    }
                }}
                ref={ref}
                type={type}
                {...props}
            />
        );
    },
);
Input.displayName = "Input";

export { Input };
